export default class ArrayUtils {
    static add(element:any, arr: any[]) {
        arr.push(element);
    }
}